import * as MessageShared from "../../../darvin-shared/schema/zod/agent/message-types.schema";

export enum AssistantMessageAnimationStatus {
  WAITING = "waiting", // Message is queued but not yet visible
  ANIMATING = "animating", // Message is currently being animated
  DISPLAYED = "displayed", // Message has finished animating and is fully displayed
}

export abstract class ProjectChatElement {
  constructor(public readonly id: string, public readonly timestamp: number) {}
}

export class ProjectChatUserMessage extends ProjectChatElement {
  constructor(
    public readonly id: string,
    public readonly timestamp: number,
    public readonly value: MessageShared.UserMessage,
    public readonly checkpointId: string
  ) {
    super(id, timestamp);
  }
}

export class ProjectChatTemporaryUserMessage extends ProjectChatElement {
  constructor(
    public readonly id: string,
    public readonly timestamp: number,
    public readonly content: string,
    public readonly attachedFile: MessageShared.UserMessageAttachment | null
  ) {
    super(id, timestamp);
  }
}

export class ProjectChatAssistantMessage extends ProjectChatElement {
  constructor(
    public readonly id: string,
    public readonly timestamp: number,
    public animationStatus: AssistantMessageAnimationStatus,
    public visibleWords: number,
    public fullyGenerated: boolean,
    public value:
      | MessageShared.ProjectConfig
      | MessageShared.GeneralAssistantMessage
      | MessageShared.CodeContent
      | MessageShared.ErrorContent
      | { type: "notEnoughTokens" }
      | { type: "runtime"; message: string },
    public readonly type: ProjectChatAssistantMsgType
  ) {
    super(id, timestamp);
  }
}

export type ProjectChatAssistantMsgType =
  | "projectConfig"
  | "general"
  | "code"
  | "error";

export class ProjectChatException {
  constructor(public readonly message: string) {}
}
